
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M3.667 10.667h40V20s-3.666.497-3.666 4 3.666 4.11 3.666 4.11v9.223"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M43.668 10.667h-40V20s3.666.497 3.666 4-3.667 4.11-3.667 4.11v9.223h40"}}),_c('path',{attrs:{"stroke":"#234652","stroke-dasharray":"3 3","stroke-linecap":"square","d":"M15 11v26"}}),_c('rect',{attrs:{"width":"18.869","height":"18.869","x":"29.138","y":"10.482","fill":"#D0EFEC","rx":"9","transform":"rotate(45.619 29.138 10.482)"}}),_c('circle',{attrs:{"cx":"26.174","cy":"20.942","r":"2.5","stroke":"#234652","transform":"rotate(18.765 26.174 20.942)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M33.997 18.928 23.99 28.72"}}),_c('circle',{attrs:{"cx":"31.814","cy":"26.706","r":"2.5","stroke":"#234652","transform":"rotate(18.765 31.814 26.706)"}})])
          )
        }
      }
    